export const componentStyles = {
  backgroundStyles: {
    backgroundSize: "cover",
    backgroundPosition: "center center",
    backgroundRepeat: "no-repeat",
    width: "100%",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  rowContainer: {
    color: "#233658",
    textAlign: "center",
    fontFamily: "Open Sans",
    fontSize: "30px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "120%",
    letterSpacing: "0.18px",
    marginBottom: "15px",
  },
  usernameContainer: {
    margin: "10px 0px",
  },
  formLabel: {
    color: "#476788",
    fontFamily: "Open Sans",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "120%",
    letterSpacing: "0.08px",
  },
  submitBtn: {
    display: "flex",
    width: "100%",
    height: "44px",
    padding: "14px 24px",
    justifyContent: "center",
    alignItems: "center",
    gap: "10px",
    flexShrink: 0,
    fontWeight: 600,
    border: "none",
    borderRadius: "8px",
    background: "#E65088",
    marginTop: "8px",
    marginBottom: "10px",
  },
  formMargins: {
    margin: "12px",
  },
};
